import React from "react";

interface RankMetricsProps {
  sortOrder: number;
  isFullMatch: boolean;
  isFullTime: boolean;
  matchCount: number;
  conditionCount: number;
  bookedMinutes: number;
  periodCapMinutes: number | null;
  isAtCap: boolean;
  isPrioritized: boolean;
}

const hours = (minutes: number): string => `${Math.round(minutes / 60)}h`;

/**
 * One line of "why this provider ranks here", in the ranker's own order: match tier,
 * then the target tier (at target or not, and prioritized), then employment type,
 * then load against target. Staff preview only; the patient flow never renders it.
 */
const RankMetrics: React.FC<RankMetricsProps> = ({
  sortOrder,
  isFullMatch,
  isFullTime,
  matchCount,
  conditionCount,
  bookedMinutes,
  periodCapMinutes,
  isAtCap,
  isPrioritized,
}) => {
  const parts: string[] = [`#${sortOrder + 1}`];

  if (isFullMatch) {
    parts.push("Full match");
  } else {
    parts.push(
      `${matchCount}/${conditionCount} ${conditionCount === 1 ? "condition" : "conditions"}`,
    );
  }

  if (isAtCap) {
    parts.push("At target");
  }

  if (isPrioritized) {
    parts.push("Offer first");
  }

  if (isFullTime) {
    parts.push("Full-time");
  }

  parts.push(
    periodCapMinutes === null
      ? `${hours(bookedMinutes)} booked this pay period (no target)`
      : `${hours(bookedMinutes)} of ${hours(periodCapMinutes)} target booked this pay period`,
  );

  return (
    <div className="mb-1 text-xs font-medium text-neutral-500">
      {parts.join(" · ")}
    </div>
  );
};

export default RankMetrics;
